<template>
    <div id="new-trendyol-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("message.channelName") }}</label>
                    <a-form-item>
                        <a-input v-model="form.channelName" :placeholder="$t('message.channelName')" />
                    </a-form-item>
                </div>
                <div class="input-wrapper">
                    <label>{{ $t("message.trendyolSellerIdLabel") }}</label>
                    <a-input v-model="form.sellerId" :placeholder="$t('message.trendyolSellerIdPlaceholder')" />
                </div>
                <div class="input-wrapper">
                    <label>{{ $t("message.trendyolApiKeyFieldLabel") }}</label>
                    <a-input v-model="form.apiKey" :placeholder="$t('message.trendyolApiKeyPlaceholder')" />
                </div>
                <div class="input-wrapper">
                    <label>{{ $t("message.trendyolApiSecretKeyLabel") }}</label>
                    <a-input v-model="form.apiSecretKey" :placeholder="$t('message.trendyolApiSecretKeyPlaceholder')" />
                </div>
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">{{$t("wp.cancel")}}</a-button>
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading"
                    >{{$t("message.save")}}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "NewTrendyolChannel",
    data() {
        return {
            form: {
                channelName: "",
                sellerId: "",
                apiKey: "",
                apiSecretKey: "",
            },
            loading: false,
        };
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        handleCancel() {
            this.$emit("cancel");
        },
        handleSave() {
            const payload = {
                type: "trendyol",
                name: this.form.channelName,
                payload: {
                    sellerId: this.form.sellerId,
                    apiKey: this.form.apiKey,
                    apiSecretKey: this.form.apiSecretKey,
                },
                commentForward: {
                    mode: "ticket",
                    story: null,
                },
            };
            this.loading = true;
            this.createChannel(payload)
                .then(() => {
                    this.$message.success(this.$t("message.channelCreatedSuccess"));
                    this.$emit("ok");
                })
                .catch((err) => {
                    this.$message.error(this.$t("message.channelCreatedError"));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
